import {callAjaxGet, objectToFormData} from "../../utils";
import $ from "jquery";
import {getExternByFamily, postExtern} from "../usuario/usuario";

export const getCargosMTA = async (errorHandling) => {
    const cargos = await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/mta/cargos`, errorHandling);
    return cargos.map(c => {
        return {
            ...c, front: diccionarioCargos[diccionarioCargos.findIndex(a => a.api_name === c.cargo)].front
        }
    })
}

export const getCargoMTAById = async (chargeId, errorHandling) => {
    const cargo = await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/mta/cargos/${chargeId}`, errorHandling);
    return {
        ...cargo,
        front: diccionarioCargos[diccionarioCargos.findIndex(a => a.api_name === cargo.cargo)].front
    }
}

export const getPeopleByCargoMta = async (charge, errorHandling) => {
    return await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/mta/cargos?cargo=${charge}`, errorHandling);
}

export const getCargosExtHerMta = async (errorHandling) => {
    const cargos = await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/familia/disponibles`, errorHandling);
    const cargosMTA = {cargosHer: cargos["mta"].cargosHer, cargosExt: cargos["mta"].cargosExt}
    const translated = {
        cargosHer: cargosMTA.cargosHer.map(c => diccionarioCargos.find(d => d.api_name === c).front),
        cargosExt: cargosMTA.cargosExt.map(c => diccionarioCargos.find(d => d.api_name === c).front),
    }

    return translated;
};

export const getCargosExtHerPaises = async (errorHandling) => {
    const cargos = (await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/familia/disponibles`, errorHandling)).pais;
    cargos.cargosHer = cargos.cargosHer.map(c => diccionarioCargosPais.find(d => d.api_name === c).front);
    cargos.cargosExt = cargos.cargosExt.map(c => diccionarioCargosPais.find(d => d.api_name === c).front);
 
    return cargos;
};

//obtener paises de la mta jose
export const getPaises = async (errorHandling) => {
    return await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/mta/pais`, errorHandling);
}

//obtiene los cargos del pais asignados
export const getCargosPaises = async (paisId, errorHandling) => {
    const cargosPais = await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/mta/pais/${paisId}/cargos`, errorHandling);
    return cargosPais.map(c => {
        return {
            ...c, front: diccionarioCargosPais[diccionarioCargosPais.findIndex(a => a.api_name === c.cargo)].front
        }
    })
 }

// Lo usamos para traducir entre los nombres de los cargos en la api y los cargos en el frontend
const diccionarioCargosPais = [
    {
        api_name: "Hermana Delegada Nacional",
        front: {name: "Componentes del equipo", charge: "Hermana Delegada Nacional"}
    },
    {
        api_name: "Coordinador/a",

        front: {name: "Componentes del equipo", charge: "Coordinación"}
    },
    {
        api_name: "Vicecoordinador/a",
        front: {name: "Componentes del equipo", charge: "Vicecoordinación"}
    },
    {
        api_name: "Secretario/a",
        front: {name: "Componentes del equipo", charge: "Secretaría"}
    },
    {
        api_name: "Tesorero/a",
        front: {name: "Componentes del equipo", charge: "Tesorería"}
    },
    {
        api_name: "Representante del Equipo Continental",
        front: {name: "Componentes del equipo", charge: "Representante del equipo continental"}
    },
    {
        api_name: "Otros miembros",
        front: {name: "Componentes del equipo", charge: "Otros miembros"}
    },
]

const diccionarioCargos = [
    {
        front: {name: "Directora general", charge: "Directora"},
        api_name: "Directora general"
    },
    {
        front: {name: "Equipos continental Europa", charge: "Coordinadora de mesa"},
        api_name: "Coordinador/a Equipos Continental Europa"
    },
    {
        front: {name: "Equipos continental America", charge: "Coordinadora de mesa"},
        api_name: "Coordinador/a Equipos Continental América"
    },
    {
        front: {name: "Equipos continental Africa", charge: "Coordinadora de mesa"},
        api_name: "Coordinador/a Equipos Continental África"
    },
    {
        front: {name: "", charge: ""},
        api_name: "Administracion"
    },
    {
        front: {name: "Equipos continental Europa", charge: "Miembros de la mesa"},
        api_name: "Miembro mesa Europa"
    },
    {
        front: {name: "Equipos continental America", charge: "Miembros de la mesa"},
        api_name: "Miembro mesa América"
    },
    {
        front: {name: "Equipos continental Africa", charge: "Miembros de la mesa"},
        api_name: "Miembro mesa África"
    },
    {
        front: {name: "Equipos continental Europa", charge: "Delegada general"},
        api_name: "Delegada general Europa"
    },
    {
        front: {name: "Equipos continental America", charge: "Delegada general"},
        api_name: "Delegada general América"
    },
    {
        front: {name: "Equipos continental Africa", charge: "Delegada general"},
        api_name: "Delegada general África"
    },
    {
        front: {name: "Equipos continental Europa", charge: "Miembros de otros paises"},
        api_name: "Otros miembros Europa"
    },
    {
        front: {name: "Equipos continental America", charge: "Miembros de otros paises"},
        api_name: "Otros miembros América"
    },
    {
        front: {name: "Equipos continental Africa", charge: "Miembros de otros paises"},
        api_name: "Otros miembros África"
    },
    {
        front: {name: "Equipos continental Europa", charge: "Delegada continental"},
        api_name: "Delegada continental Europa"
    },
    {
        front: {name: "Equipos continental America", charge: "Delegada continental"},
        api_name: "Delegada continental América"
    },
    {
        front: {name: "Equipos continental Africa", charge: "Delegada continental"},
        api_name: "Delegada continental África"
    },
]

export const formPostMta = async (nuevos, aBorrar) => {
    const promises = [];
    nuevos.forEach(nuevo => {
        const form = objectToFormData({
            startDate: nuevo.startDate,
            endDate: nuevo.endDate,
            cargo: diccionarioCargos.find(c => c.front.name === nuevo.front.name && c.front.charge === nuevo.front.charge).api_name,
            externoId: nuevo.externoId,
            sisterId: nuevo.sisterId,

        }, true);
        if (nuevo.id) {
            promises.push(putCargoMta(form, nuevo.id))
        } else {
            promises.push(postCargoMta(form))
        }
    })

    aBorrar.forEach(borrar => {
        promises.push(deleteCargoMta(borrar.id))
    })

    for (let promise in promises) {
        try {
            await promise;
        } catch (e) {
            alert(e)
        }
    }
}

export const postCargoMta = async (cargo) => {
    let settings = {
        url: process.env.REACT_APP_API_URL + `/mta/cargos`,
        method: "POST",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
        data: cargo,
    };
    return $.ajax(settings);
};

export const putCargoMta = async (cargo, id) => {
    let settings = {
        url: process.env.REACT_APP_API_URL + `/mta/cargos/${id}`,
        method: "PUT",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
        data: cargo,
    };
    return $.ajax(settings);
};

export const deleteCargoMta = async (id) => {
    let settings = {
        url: process.env.REACT_APP_API_URL + `/mta/cargos/${id}`,
        method: "DELETE",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
    };
    return $.ajax(settings);
};

//////////////////////////////////  PAISES
//post cargo pais
export const postCargoPais = async (cargo, paisid) => {
    let settings = {
        url: process.env.REACT_APP_API_URL + `/mta/pais/${paisid.valor}/cargos`,
        method: "POST",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
        data: cargo,
    };
    return $.ajax(settings);
};

//put cargo pais
export const putCargoPais = async (cargo, id, paisid) => {
    let settings = {
        url: process.env.REACT_APP_API_URL + `/mta/pais/${paisid.valor}/cargos/${id}`,
        method: "PUT",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
        data: cargo,
    };
    return $.ajax(settings);
};

//borra cargo de la fet
export const deleteCargoPais = async (id, paisid) => {
    let settings = {
        url: process.env.REACT_APP_API_URL + `/mta/pais/${paisid.valor}/cargos/${id}`,
        method: "DELETE",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
    };
    return $.ajax(settings);
};

//funcion para poner los cargos de los paises jose 032022
export const formPostPaises = async (nuevos, aBorrar, paisid) => {
    //array de peticiones
    const promises = [];
    //por cada elemento nuevo creo un objeto correcto y completo
    nuevos.forEach(nuevo => {
        const form = objectToFormData({
            startDate: nuevo.startDate,
            endDate: nuevo.endDate,
            cargo: diccionarioCargosPais.find(c => c.front.name === nuevo.front.name && c.front.charge === nuevo.front.charge).api_name,
            externoId: nuevo.externoId,
            sisterId: nuevo.sisterId,
            countryId: paisid.valor,
        }, true);
      
        if (nuevo.id) {
            promises.push(putCargoPais(form, nuevo.id, paisid))
        } else {
            promises.push(postCargoPais(form, paisid))
        }
    });

    aBorrar.forEach(borrar => {
        const  res =  promises.push(deleteCargoPais(borrar.id, paisid));
        //console.log('resultado '+res)
    })

    //llamo al array de peticiones y las ejecuto
    for (let promise in promises) {
        try {
            await promise;
        } catch (e) {
            alert(e)
        }
    }
}
////////////////////////////////// FIN PAISES

export const getExternMta = async (errorHandling, name = null) => {
    return await getExternByFamily("MTA", errorHandling, name);
}

export const postExternMta = async (data) => {
    await postExtern({...data, familia: "MTA"});
};

export const putExternMta = async (data) => {
    await postExtern({...data, familia: "MTA"});
};